import { createTypes, createActions, createReducer } from '@fe/redux/reducers/util'

import _ from 'lodash/fp'

const namespace = 'claimTokens'

const typeKeys = [
  'CLAIM_REQUEST',
  'CLAIM_ERROR',
  'CLAIM_SUCCESS',
  'CLAIM_DONE',

  'LOAD_MATCH_REQUEST',
  'LOAD_MATCH_ERROR',
  'LOAD_MATCH_SUCCESS',
  'LOAD_MATCH_DONE',

  'SET_TOKEN_TO_GAME_ID'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

const initialState = {
  claimRequestWaiting: false,
  claimDoneAt: null,
  claimSuccessAt: null,
  claimErrorAt: null,
  tokenMap: {}
}

const reducer = {
  [types.CLAIM_REQUEST]: p => _.flow(
    _.set('claimRequestWaiting', true),
    _.set('claimErrorAt', null),
    _.set('claimSuccessAt', null),
    _.set('claimDoneAt', null)),
  [types.CLAIM_ERROR]: p => _.set('claimErrorAt', Date.now()),
  [types.CLAIM_SUCCESS]: p => _.set('claimSuccessAt', Date.now()),
  [types.CLAIM_DONE]: p => _.flow(
    _.set('claimRequestWaiting', false),
    _.set('claimDoneAt', Date.now())
  ),
  [types.SET_TOKEN_TO_GAME_ID]: ({ claimToken, gameId }) => _.set(`tokenMap.${claimToken}`, gameId)
}

export default createReducer(initialState, reducer)

function createSelectors () {
  const claimTokens = _.get(namespace)
  const claimRequestWaiting = _.flow(claimTokens, _.get('claimRequestWaiting'))
  const claimDoneAt = _.flow(claimTokens, _.get('claimDoneAt'))
  const claimSuccessAt = _.flow(claimTokens, _.get('claimSuccessAt'))
  const claimErrorAt = _.flow(claimTokens, _.get('claimErrorAt'))
  const getGameIdFromToken = token => _.get(`${namespace}.tokenMap.${token}`)
  return {
    claimTokens,
    claimRequestWaiting,
    claimDoneAt,
    claimSuccessAt,
    claimErrorAt,
    getGameIdFromToken
  }
}

export const selectors = createSelectors()
